export const toastConstants = {
  SUCCESS_TIMEOUT: 500,
  INFO_TIMEOUT: 3000,
  ERROR_TIMEOUT: 5000,
  NOTICE_TIMEOUT: 20000
};
